const { algoliasearch, instantsearch } = window;

// ID & Key
const algoliaClient = algoliasearch(
  '3MMVVHL446',
  '359405eb9d9a709c410b5fc9c1e80ee8'
);

// Hide Empty Queries from Analytics
const searchClient = {
  search(requests) {
    console.log(requests)
    const newRequests = requests.map((request)=>{
      if(!request.params.query || request.params.query.length===0) {
        request.params.analytics=false
      }
      return request
    });
    return algoliaClient.search(newRequests);
  },
};

// Product Index
const search = instantsearch({
  indexName: 'prod_shopify_products',
  searchClient,
});

// Product Template
const renderProductHits = (renderOptions, isFirstRender) => {
  const { hits, widgetParams } = renderOptions;
  widgetParams.container.innerHTML = `
    <div class="swiper card-feature swiper-initialized swiper-horizontal swiper-pointer-events">
      <div class="swiper-wrapper">
      ${hits
        .map(
          item =>
            `<div class="swiper-slide">
              <a href="https://shop.ekohealth.com/products/${item.handle}">
                <div class="image swiper-lazy swiper-lazy-loaded" style="background-image: url('${item.image}');" /></div>
                <div class="name">${instantsearch.highlight({ attribute: 'title', hit: item })}</div>
                <div class="variant">Color: ${item.variant_title}</div>
              </a>
            </div>`
        )
        .join('')}
      </div>
      <div class="swiper-pagination swiper-pagination-clickable swiper-pagination-bullets swiper-pagination-horizontal"></div>
      <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
    </div>
  `;
};

// Product Widgets
const productHits = instantsearch.connectors.connectHits(renderProductHits);
search.addWidgets([
  productHits({
    container: document.querySelector('#products'),
  }),
  instantsearch.widgets.stats({
    container: '#products-stats',
    templates: {
      text: `
      {{#hasManyResults}}({{nbHits}}){{/hasManyResults}}
      {{#hasOneResult}}(1){{/hasOneResult}}
      {{#hasNoResults}}(0){{/hasNoResults}}
      `
    }
  }),
  instantsearch.widgets.configure({
    hitsPerPage: 8,
  }),
]);

// Content Hits
let lastRenderArgs;
const infiniteContentHits = instantsearch.connectors.connectInfiniteHits(
  (renderArgs, isFirstRender) => {
    const { hits, showMore, widgetParams } = renderArgs;
    const { container } = widgetParams;
    lastRenderArgs = renderArgs;
    if (isFirstRender) {
      const sentinel = document.createElement('div');
      container.appendChild(document.createElement('div'));
      container.appendChild(sentinel);
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !lastRenderArgs.isLastPage) {
            showMore();
          }
        });
      });
      observer.observe(sentinel);
      return;
    }
    container.querySelector('div').innerHTML = hits
      .map(
        hit =>
          `<div class="hit">
          <a href="https://www.ekohealth.com/articles/${hit.slug}">
            <div class="image" style="background: url('${hit.image}') no-repeat; background-size: cover;"></div>
            <div class="hit-details">
              <div class="title">${instantsearch.highlight({ attribute: 'title', hit: hit })}</div>
              <div class="summary">${hit.summary}</div>
              <div class="date">${hit.date}</div>
              <div class="draft">${hit.draft}</div>
              <div class="archive">${hit.archive}</div>
            </div>
          </a>
        </div>`
      )
      .join('');
  }
);

// Content widgets
search.addWidgets([
  // Webflow Index
  instantsearch.widgets.index({ indexName: 'prod_WEBFLOW' })
    .addWidgets([
      infiniteContentHits({
        container: document.querySelector('#content'),
      }),
      instantsearch.widgets.stats({
        container: '#content-stats',
        templates: {
          text: `
          {{#hasManyResults}}({{nbHits}}){{/hasManyResults}}
          {{#hasOneResult}}(1){{/hasOneResult}}
          {{#hasNoResults}}(0){{/hasNoResults}}
          `
        }
      }), 
    ])
  ,
]);

// Support Hits
const infiniteSupportHits = instantsearch.connectors.connectInfiniteHits(
  (renderArgs, isFirstRender) => {
    const { hits, showMore, widgetParams } = renderArgs;
    const { container } = widgetParams;
    lastRenderArgs = renderArgs;
    if (isFirstRender) {
      const sentinel = document.createElement('div');
      container.appendChild(document.createElement('div'));
      container.appendChild(sentinel);
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !lastRenderArgs.isLastPage) {
            showMore();
          }
        });
      });
      observer.observe(sentinel);
      return;
    }
    container.querySelector('div').innerHTML = hits
      .map(
        hit =>
          `<div class="hit">
            <a href="https://support.ekohealth.com/hc/en-us/articles/${hit.id}">
              <div class="hit-details">
                <div class="title">${instantsearch.highlight({ attribute: 'title', hit: hit })}</div>
                <div class="summary">${hit.body_safe}</div>
                <div class="date">${hit.updated_at_iso}</div>
              </div>
            </a>
          </div>`
      )
      .join('');
  }
);

// Support widgets
search.addWidgets([
  // Zendesk Index
  instantsearch.widgets.index({ indexName: 'zendesk_ekodevices_articles' })
    .addWidgets([
      infiniteSupportHits({
        container: document.querySelector('#support'),
      }),
      instantsearch.widgets.stats({
        container: '#support-stats',
        templates: {
          text: `
          {{#hasManyResults}}({{nbHits}}){{/hasManyResults}}
          {{#hasOneResult}}(1){{/hasOneResult}}
          {{#hasNoResults}}(0){{/hasNoResults}}
          `
        }
      }),    
    ])
  ,
]);

// Search Box
search.addWidgets([
  instantsearch.widgets.searchBox({
    container: '#searchbox',
    placeholder: 'Search',
  }),
]);

search.on('render', function () {

  // Swiper    
  var swiper = new Swiper("#search-container .swiper.card-feature", {
    spaceBetween: 30,
    preloadImages: false,
    lazy: true,
    slidesPerView: 3,
    speed: 660,
    watchSlidesProgress: true,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    pagination: {
      el: '#search-container .swiper-pagination',
      clickable: true
    },      
    breakpoints: {
      0: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      468: {
        slidesPerView: 3,
        spaceBetween: 25,
      },
      600: {
        slidesPerView: 4,
        spaceBetween: 30,
      }
    }
  });

  // Remove draft, archive, and null    
  $(".draft:contains('true')").closest(".hit").remove();
  $(".archive:contains('true')").closest(".hit").remove();
  $(".summary:contains('null')").closest(".hit").remove();
  $(".variant:contains('Default Title')").remove();

  // Update Date Format
  $(".date").each(function () {
    const utcDate = $(this).html();    
    const date = new Date(utcDate);
    $(this).html("Date: " + date.toDateString().split(' ').slice(1).join(' '));
  });

  // Limit Support Summary Characters
  $("#support .summary").text(function(index, currentText) {
    return currentText.substr(0, 175) + '...';
  });

  // Tabs
  $(".tab-nav").click(function() {
    var tbs = $(this).attr("data-tab");
    $(".tab-nav, .tab-content").removeClass("active-tab");
    $(this).addClass("active-tab");
    $("#" + tbs).addClass("active-tab");
  });
  $(".tab-nav").click(function() {
    var tbs = $(this).attr("data-tab");
    $(".tab-nav, .tab-content").removeClass("active-tab");
    $(this).addClass("active-tab");
    $("#" + tbs).addClass("active-tab");
  });   
  if ($("#support .hit").is(":visible") && $("#content .hit").is(":hidden")) {
    $("#tab-support").addClass("active-tab");
    $("#tab-content").removeClass("active-tab");
  }

  // Hit Lengths
  let productHits = $("#products").find(".swiper-slide").length;   
  let contentHits = $("#tab-content").find(".hit").length;
  let supportHits = $("#tab-support").find(".hit").length;    
    
  // Hide/Show Products Tab
  if (productHits < 1) {
    $("#products").closest(".row").hide();
  } else {
    $("#products").closest(".row").show();  
  }
    
  // Hide/Show Content Tab
  if (contentHits < 1) {
    $(".tab-nav[data-tab='tab-content']").hide();
    $("#tab-content").removeClass("active-tab");
  } else {
    $(".tab-nav[data-tab='tab-content']").show();
    $("#tab-content").addClass("active-tab");
  }
    
  // Hide/Show Support Tab
  if (supportHits < 1) {
    $(".tab-nav[data-tab='tab-support']").hide();
    $("#tab-support").removeClass("active-tab");
  } else {
    $(".tab-nav[data-tab='tab-support']").show();
    $("#tab-support").addClass("active-tab");
  }      
  
  // Show Content/Hide Support
  if ((supportHits < 1) && (contentHits > 0)) {
    $("#tab-content").addClass("active-tab");  
    $("#tab-support").removeClass("active-tab");
    $(".tab-nav[data-tab='tab-content']").addClass("active-tab");  
    $(".tab-nav[data-tab='tab-support']").removeClass("active-tab");  
  }
    
  // Show Support/Hide Content
  if ((contentHits < 1) && (supportHits > 0)) {
    $("#tab-support").addClass("active-tab");  
    $("#tab-content").removeClass("active-tab");  
    $(".tab-nav[data-tab='tab-support']").addClass("active-tab");  
    $(".tab-nav[data-tab='tab-content']").removeClass("active-tab");
  } 
    
  // Show Content by Default
  if ((supportHits > 0) && (contentHits > 0)) {
    $("#tab-content").addClass("active-tab");  
    $("#tab-support").removeClass("active-tab");
    $(".tab-nav[data-tab='tab-content']").addClass("active-tab");  
    $(".tab-nav[data-tab='tab-support']").removeClass("active-tab");    
  }   
    
  // Hide Everything  
  if ((productHits < 1) && (contentHits < 1) && (supportHits < 1)) {
    $("#no-results").show();
  } else {
    $("#no-results").hide();
  }

});

search.start();

// Open Search
$("#show-search").click(function() {
  $("#search-container").show();
  $("#search-container").addClass("show-search");
  $(".ais-SearchBox-input").focus();
  $("body").addClass("search-open");
});

// Close Search
$("#hide-search").click(function() {
  $("#search-container").hide();
  $("#search-container").removeClass("show-search");
  $("body").removeClass("search-open");
});

